module.exports = __webpack_public_path__ + "static/media/ms-small.c2ad0cf2.png";